<template>
  <div class="modal-wpr" v-if="showModalResults">
    <div class="modal-bg" @click="setShowModalResults(false)"></div>
    <div class="modal">
      <div class="header">
        <svg width="60" height="51" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 9a9 9 0 0 1 9-9h42a9 9 0 0 1 9 9v33a9 9 0 0 1-9 9H9a9 9 0 0 1-9-9V9Z" fill="url(#a)" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="m23.337 24.72 2.279-6.83h1.398l2.279 6.83 6.837 2.277v1.397l-6.837 2.276-2.279 6.83h-1.398l-2.28-6.83-6.836-2.276v-1.397l6.837-2.277ZM36.235 15.516 37.408 12h1.399l1.173 3.516 3.52 1.172v1.398l-3.52 1.172-1.173 3.516h-1.399l-1.173-3.516-3.52-1.172v-1.398l3.52-1.172Z"
            fill="#fff" />
          <defs>
            <linearGradient id="a" x1="3.75" y1="0" x2="49.5" y2="54" gradientUnits="userSpaceOnUse">
              <stop stop-color="#00B2FF" />
              <stop offset="1" stop-color="#EB00FF" />
            </linearGradient>
          </defs>
        </svg>
        <div class="query">
          {{ responseContent }}
        </div>
      </div>
      <div v-for="product in relevantProductsFull" :key="product.sku" class="result">
        <img :src="product.productImage" alt="">
        <p class="sale-price"><span v-if="product.priceQuantity">{{ `${product.priceQuantity} ` }}</span>${{
          product.salePrice || product.salePriceFr }} <span class="unit">{{ product.promoUnitEn }}</span></p>
        <p class="name">{{ product.productEn }}</p>
        <p class="details">{{ product.bodyEn }}</p>
      </div>
      <div class="footer">
        <p>Powered by:</p>
        <svg width="95" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#a)" fill="#231F20">
            <path
              d="M33.233 11.156a2.485 2.485 0 1 1-4.97.003 2.485 2.485 0 0 1 4.97-.003ZM23.354 15.894c.05.051.085.12.085.2 0 .067-.02.13-.063.178A7.743 7.743 0 0 1 9.82 11.157a7.744 7.744 0 0 1 7.743-7.747c2.239 0 4.249.955 5.666 2.472a.28.28 0 0 1 .01.37l-2.274 2.37a.261.261 0 0 1-.38.01 4.086 4.086 0 0 0-3.023-1.338c-2.134 0-3.726 1.73-3.726 3.863 0 2.13 1.592 3.862 3.726 3.862 1.232 0 2.353-.485 3.12-1.338a.259.259 0 0 1 .188-.079c.07 0 .14.03.185.08l2.3 2.212ZM6.01.271c-.1.06-5.465 3.4-5.465 3.4-.151.082-.295.3-.295.455v2.952c0 .155.125.28.28.28h1.212c.157 0 .283.126.283.282l.002 5.17c0 4.585 2.676 5.976 5.972 5.976.522 0 1.028-.067 1.508-.194.154-.035.24-.134.24-.277V15.22a.283.283 0 0 0-.281-.282h-.055c-.318.013-.829.032-1.41.032a1.748 1.748 0 0 1-1.748-1.747v-.907l-.007-.071V7.64c0-.156.128-.282.282-.282h2.937a.28.28 0 0 0 .28-.28V4.024a.282.282 0 0 0-.28-.282l-2.937.01a.285.285 0 0 1-.282-.286V.374c0-.09-.135-.162-.236-.103ZM40.816 9.355h-.882l-.076.077v4.061l-.077.077h-.536l-.077-.077v-4.06l-.077-.078h-.881l-.077-.076v-.46l.077-.077h2.605l.077.077v.46l-.076.076ZM43.995 10.045a.696.696 0 0 0-.69-.69h-.843l-.077.077v1.303l.077.076h.843c.376 0 .69-.314.69-.69v-.076Zm.658 3.525h-.59l-.068-.054-.713-2.046-.061-.046h-.759l-.077.077v1.992l-.076.077h-.537l-.077-.077V8.82l.077-.077h1.533c.843 0 1.379.536 1.379 1.38v.076c0 .413-.368.896-.667 1.035l-.045.06c0 .024.03.1.06.185l.637 1.839c.03.09.061.161.061.192l-.077.061ZM47.265 11.6l-.33-1.294c-.015-.063-.076-.276-.092-.338h-.03c-.015.062-.076.291-.092.344l-.33 1.258c-.023.09-.053.168-.053.206l.085.07h.804l.085-.07c0-.03-.024-.091-.047-.176Zm1.196 1.97h-.575l-.077-.054-.283-1.011-.076-.046h-1.242l-.077.046-.283 1.011-.076.054h-.576l-.084-.062c0-.03.038-.146.077-.26l1.356-4.453.077-.053h.414l.076.053 1.364 4.476c.03.091.069.207.069.237l-.084.062ZM52.244 13.57h-.49l-.07-.038-1.631-2.966a3.138 3.138 0 0 1-.137-.277l-.032.01c.015.183.023 1.172.023 1.776v1.418l-.076.077h-.537l-.076-.077V8.82l.076-.077h.49l.07.039 1.632 2.973c.024.038.115.214.138.276l.03-.007a49.637 49.637 0 0 1-.023-1.779V8.82l.078-.077h.534l.078.077v4.675l-.077.076ZM54.734 13.646h-.322c-.612 0-.958-.245-1.157-.56-.07-.106-.107-.184-.107-.222l.038-.06.39-.2.139-.06.061.053c.131.283.383.436.636.436h.322c.375 0 .69-.314.69-.69 0-.483-.445-.682-.927-.903-.599-.269-1.265-.575-1.265-1.472 0-.767.536-1.303 1.38-1.303h.122c.613 0 .957.253 1.165.56.045.069.107.168.107.207l-.046.069-.414.206-.114.046-.062-.046c-.138-.275-.383-.428-.636-.428h-.123a.696.696 0 0 0-.69.689c0 .444.483.614.996.85.575.261 1.197.614 1.197 1.525 0 .768-.537 1.303-1.38 1.303ZM59.56 13.156c-.215.276-.544.49-1.11.49h-.231c-.844 0-1.38-.536-1.38-1.302V9.968c0-.766.536-1.302 1.38-1.302h.23c.544 0 .874.2 1.088.46.108.138.184.275.184.306l-.046.068-.398.2-.13.054-.062-.046c-.138-.276-.384-.43-.636-.43h-.23a.697.697 0 0 0-.69.69v2.376c0 .376.314.69.69.69h.23c.26 0 .498-.154.643-.444l.062-.047.123.053.405.207.046.054c0 .039-.07.169-.168.3ZM62.592 9.968a.696.696 0 0 0-.69-.69h-.23a.698.698 0 0 0-.69.69v2.376c0 .376.315.69.69.69h.23c.377 0 .69-.315.69-.69V9.968Zm-.69 3.678h-.23c-.843 0-1.378-.535-1.378-1.303V9.969c0-.766.535-1.302 1.379-1.302h.23c.842 0 1.38.536 1.38 1.302v2.376c0 .767-.538 1.302-1.38 1.302ZM67.204 13.57h-.49l-.07-.038-1.632-2.966a3.111 3.111 0 0 1-.138-.277l-.03.01c.014.183.023 1.172.023 1.776v1.418l-.077.077h-.536l-.076-.077V8.82l.076-.077h.49l.069.039 1.632 2.973c.023.038.115.214.139.276l.03-.007a49.88 49.88 0 0 1-.022-1.779V8.82l.075-.077h.537l.077.077v4.675l-.077.076ZM70.658 9.355h-.882l-.076.077v4.061l-.077.077h-.535l-.078-.077v-4.06l-.076-.078h-.882l-.075-.076v-.46l.075-.077h2.606l.076.077v.46l-.076.076ZM72.075 13.57h-.537l-.076-.077V8.818l.076-.076h.537l.076.076v4.675l-.076.077ZM76.303 13.57h-.49l-.069-.038-1.633-2.966a3.162 3.162 0 0 1-.137-.277l-.03.01c.015.183.022 1.172.022 1.776v1.418l-.077.077h-.535l-.078-.077V8.82l.078-.077h.49l.068.039 1.633 2.973a3.3 3.3 0 0 1 .139.276l.03-.007a49.88 49.88 0 0 1-.023-1.779V8.82l.076-.077h.536l.077.077v4.675l-.077.076ZM80.133 13.57h-2.605l-.078-.077V8.818l.078-.076h2.605l.077.076v.46l-.077.077h-1.915l-.077.077v1.303l.076.075h1.571l.077.078v.46l-.077.076h-1.57l-.077.077v1.379l.076.077h1.916l.077.076v.46l-.077.077ZM84.177 13.57h-.49l-.069-.038-1.632-2.966a3.317 3.317 0 0 1-.138-.277l-.03.01c.015.183.023 1.172.023 1.776v1.418l-.076.077h-.538l-.075-.077V8.82l.075-.077h.492l.068.039 1.633 2.973c.023.038.115.214.137.276l.03-.007a49.593 49.593 0 0 1-.022-1.779V8.82l.077-.077h.535l.078.077v4.675l-.078.076ZM87.609 9.355h-.881l-.078.077v4.061l-.076.077h-.536l-.076-.077v-4.06l-.077-.078h-.882l-.077-.076v-.46l.078-.077h2.605l.077.077v.46l-.077.076ZM89.768 11.6l-.33-1.294c-.014-.063-.075-.276-.091-.338h-.03c-.015.062-.078.291-.094.344l-.33 1.258c-.022.09-.052.168-.052.206l.084.07h.805l.085-.07c0-.03-.024-.091-.047-.176Zm1.195 1.97h-.574l-.077-.054-.283-1.011-.077-.046h-1.241l-.077.046-.285 1.011-.075.054h-.575l-.084-.062c0-.03.038-.146.077-.26l1.355-4.453.078-.053h.414l.076.053 1.364 4.476c.03.091.069.207.069.237l-.085.062ZM94.45 13.57h-2.606l-.077-.077V8.818l.077-.076h.536l.077.076v4.062l.076.077h1.916l.077.076v.46l-.077.077Z" />
          </g>
          <defs>
            <clipPath id="a">
              <path fill="#fff" d="M0 0h94.776v19.15H0z" />
            </clipPath>
          </defs>
        </svg>
      </div>

    </div>
  </div>
</template>

<script>
import {mapGetters, mapState, mapActions} from 'vuex';

export default {
  computed: {
    ...mapGetters('search', ['relevantProductsFull', 'responseContent']),
    ...mapState('search', ['showModalResults', 'resultsLoading'])
  },

  methods: {
    ...mapActions('search', ['setShowModalResults'])
  }
}
</script>

<style scoped lang="scss">
  .modal-wpr {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .modal-bg {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
  
  .modal {
    background-color: #F2F2F2;
    box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.25);
    padding: 2em 1em;
    display: grid;
    gap: 10px;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    max-height: 80vh;
    max-width: 60vw;
    overflow: auto;
    z-index: 2;

    .header {
      grid-column: 1 / span 4;
      margin-bottom: 20px;
      display: flex;
      gap: 20px;

      svg {
        min-width: 60px;
      }
    }
    
    .result {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      background-color: white;
      border: 1px solid #E5E5E5;
      padding: 10px;
      max-width: 200px;

      img {
        align-self: center;
        width: 100px;
        height: 100px;
        object-fit: contain;
      }

      .sale-price {
        font-size: 32px;
        font-weight: 700;
        color: #EE3326;

        .unit {
          font-size: 12px;
        }
      }

      .name {
        font-size: 13px;
        font-weight: 700;
      }

      .details {
        font-size: 11px;
      }
    }

    .footer {
      grid-column: 1 / span 4;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 10px;
      font-size: 12px;
      margin-top: 2em;
    }
  }
  
  @keyframes Gradient {
    0% {
      background-position: 0% 50%;
    }

    50% {
      background-position: 100% 50%;
    }

    100% {
      background-position: 0% 50%;
    }
  }
</style>